import { render, staticRenderFns } from "./BaSendAllBidWantedModal.vue?vue&type=template&id=c1a700c2&scoped=true&"
import script from "./BaSendAllBidWantedModal.vue?vue&type=script&lang=js&"
export * from "./BaSendAllBidWantedModal.vue?vue&type=script&lang=js&"
import style0 from "./BaSendAllBidWantedModal.vue?vue&type=style&index=0&id=c1a700c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a700c2",
  null
  
)

export default component.exports